export type Lang = typeof enUS;

const enUS = {
  logoAlt: 'Passportcard logo',
  title: 'English-title',
  pageTitles: {
    baseTitle: 'Passportcard',
    existingPage: '',
    loginPage: 'Login',
    tripDetailsPage: 'Travel details',
    basicCoversPage: 'Choosing basic covers',
    additionalCoversPage: 'Choosing additional covers',
    travelersDetailsPage: 'Traveller details',
    healthDeclarationPage: 'Health declaration',
    remindersPage: 'Reminders',
    billingPage: 'Billing & Payment',
    successPage: 'Additional benefits'
  },
  autocompletePlaceholder: 'Search...',
  autocompleteErrorMsg: `Unfortunately we are unable to provide cover for this country. Please remove it from your quote to continue or call us on <a href=tel:1300-123-413 class='phone-link'>1300 123 413</a> to discuss`,
  details: 'Details',
  remove: 'Remove',
  edit: 'Edit',
  today: '',
  editDto: 'Edit date of birth',
  cancel: 'Cancel',
  add: 'Add',
  save: 'Save',
  update: 'Update',
  newPolicy: 'New policy',
  completed: 'Completed',
  loading: 'Loading...',
  gender: {
    female: 'female',
    male: 'male'
  },
  options: {
    yes: 'yes',
    no: 'no'
  },
  errorPopUpTitle: 'An error occurred while creating the policy',
  errorPopUpDescription: 'It seems that something went wrong. There is nothing to do, it happens sometimes.',
  errorPopUpInformation:
    'We invite you to try again, and if it does not work - contact us at the call center *9912 or leave details so we can contact you soon',
  close: 'Close',
  closePopUpAriaLabel: 'Close Popup Dialog {{popupTitle}}',
  coverCoverage: 'Cover coverage',
  addCoverToTravelerAriaLabel: 'Add cover {{coverName}} for {{travelerName}}',
  editCoverToTravelerAriaLabel: 'Edit cover for {{travelerName}}',
  addTravelerAriaLabel: 'Add traveller {{travelerName}}',
  editTravelerAriaLabel: 'Edit details of traveler {{travelerName}}',
  removeTravelerAriaLabel: 'Remove Traveller {{travelerName}}',
  selectAll: 'All',
  selectAllAriaLabel: 'Sellect all traveller for this cover',
  traveler: {
    whoIsTraveling: 'Who is travelling now?',
    whoIsTravelingNewCustomer: 'Who is travelling?',
    whoIsTravelingSelectAllAriaLabel: 'Select all travellers',
    whoIsTravelingSelectAll: 'Select all',
    addTravelerTitle: 'Add a traveller',
    addTravelerAriaText: 'Add date and continue to next step',
    travelers: 'Travellers',
    singleTraveler: 'One Traveller',
    addTraveler: 'Add a family member',
    traveler: 'Traveller',
    travelerShe: 'Traveller',
    travelerHe: 'Traveller',
    travelersDetailsTitle: 'Completing traveller details',
    travelersDetailsSubTitle:
      'Complete the details of the travellers.\n The policy details will be sent to the phone and email of the first traveller.',
    saveAndContinue: 'Save and continue',
    guardian: 'Guardian',
    whoIsTravelingNewCustomerSubtitle: 'Soon we will get to know each other a little more...',
    newCustomerEditLabel: 'Edit traveller',
    maxAgeExceededLeadNote: 'A Customer older than 75 was referred from the website'
  },
  travelerDetails: {
    title: 'Traveller Details',
    allInputsRequiredSubtitle:
      'All fields are mandatory. Unique mobile & email allows Traveller 2 to get travel alerts',
    inputsRequiredSubtitle: 'All fields are mandatory',
    englishFirstNameLabel: 'First name',
    englishLastNameLabel: 'Last name',
    emailLabel: 'Email address',
    dateLabel: 'DD/MM/YYYY',
    datePlaceholder: 'Date of Birth',
    dobAndAgeMismatchTitle: "Oops... the entered age and date of birth don't match",
    dobAndAgeMismatchMessage:
      'The age entered doesn’t match the traveller’s date of birth at the time of travel. No worries, we’ll update your quote to reflect this change.',
    adultDOBErrorTitle: 'An Adult DOB is under 18',
    adultDOBErrorMessage:
      "You’ve entered a date of birth that is under 18 and we cannot insure you as an adult online, please call us on <a href=tel:1300-123-413 class='phone-link'>1300 123 413</a and our customer team can help you",
    ageExceptionTitle: 'Age entered is over 85',
    ageExceptionMessage:
      "Due to the age you've entered we are not able to provide you with a quote online. Please get in touch with our Australia-based team on <a href=tel:1300-123-413 class='phone-link'>1300 123 413</a> and they can help you.",
    childDOBErrorTitle: 'A child DOB is over 25',
    childDOBErrorMessage:
      ' The date of birth entered for your child/dependant is over the age of 25 and they are required to be an adult on a policy. Please go back to Trip Details and update your quote',
    countryLabel: 'Country',
    countryNoResult: 'No results found',
    mobileLabel: 'Mobile',
    travelerLabel: 'Traveller',
    ageLabel: 'Age',
    save: 'Save Traveller',
    saveAndContinue: 'Save & Move to Next Traveller',
    update: 'Update',
    calendarNoteTitle: 'Already left?',
    calendarNoteMessage: "If you've already started your trip, this cover is subject to a 3-day no cover period."
  },
  programmaticallyAddedCoverPopup: {
    title: `We've added Traveller 2 to your selected Activity Covers`,
    information: `We've automatically added Traveller 2 to the Activity Covers that you've selected. You can remove Traveller 2 by clicking 'Details' on the Activity Cover and unselecting them.`,
    button: `Close`,
    imgAlt: `activity_cover_added_popup`
  },

  traveller: 'Traveller',
  addTraveller: 'Add Traveller',
  addAdultTraveller: 'Add Adult',
  addChildTraveller: 'Add Children / Dependants',
  continue: 'Continue',
  continueAndSave: 'Save and continue to the next question',
  continueToOTPStep: 'Continue to the next step, type the sms you received',
  continueTripDestStep: 'Continue to the next step, Trip Destination.',
  continueTripDatesStep: 'Continue to the next step, Trip Dates.',
  continueTripDetailsStep: 'Continue to the next step, Trip Details.',
  continueBasicCoversStep: 'Continue to the next step, Basic Covers',
  continueHealthDeclarationStep: 'Continue to the next step, Health Declaration',
  continueNextQuestion: 'Continue to next question',
  acceptAndContinue: 'Accept & Continue',
  age: 'Age',
  cover: 'cover',
  firstName: 'First name',
  lastName: 'Last name',
  dtoLabel: 'Date of birth',
  dtoAriaLabel: 'Please enter Date of birth',
  dayLabel: 'Day',
  monthLabel: 'Month',
  yearLabel: 'Year',
  dateError: 'Please enter a valid date',
  errorGuardianAge: 'The guardian must be at least 18 years old',
  errorIncorrectAdults:
    'Note! Adding a traveller who is not part of your family composition. You cannot select more than two adults on the policy. For an additional adult, you must purchase a separate policy',

  continuePurchase: 'Continue purchase',
  brokerPopupText: 'The property is transferred to the purchase of travel insurance PassportCard through brokers',
  newOrExistingCustomerQuestion: 'Have you already purchased a passport card before?',
  newOrExistingCustomerText:
    'If you have previously purchased a travel policy abroad with us, we can help you faster..',
  newCustomerAnswer: 'Yes',
  existingCustomerAnswer: 'No',
  newCustomerText: 'This is the first time',
  existingCustomerText: 'I have purchased from you before',
  validatorsError: {
    required: 'Required',
    email: 'Please enter a valid email address',
    phone: 'Please enter a valid phone number',
    name: 'Please enter a valid name',
    id: 'Please enter a valid id number',
    idDuplication: 'ID number is already associated with another traveller',
    nonRequired0To9999: 'You cannot set a broker fee higher than $9999.99',
    postcode: 'Invalid postcode',
    duplicatedEmail: 'Email is already associated with another traveller',
    duplicatedPhone: 'Phone number is already associated with another traveller',
    lettersOnly: 'Only letters allowed'
  },
  chooseAtLeastOneTraveler: 'Please select traveller',
  chooseAtLeastCarType: 'Please select car type',
  otpTitle: 'We sent you an SMS code',
  otpQuestion: 'What is the code you received? (6 digits)',
  otpGuidance: 'The code has been sent to a phone that ends with - ',
  otpSendAgain: 'Send again',
  otpErrorMessage: 'The code you entered is invalid',
  otpRememberMe: 'Remember me for 24 hours',
  idTitle: 'We would be happy to identify you',
  idQuestion: 'ID number',
  idQuestionAriaLabel: 'Enter ID Number, after filling ID number it will be automatically updated.',
  continueWithoutIdAriaLabel: 'Button to continue without identification',
  resendSMSAriaLabel: 'Button to send a new SMS',
  continueWithoutId: 'Continue without identification',
  idErrorMessage: 'We could not find your ID number',
  whereAreYouTravelingTitle: 'Where are you travelling?',
  whereAreYouTravelingSubtitle: 'Search for a destination',
  whereAreYouTravelingDestinations: 'Popular destinations',
  WhereAreYouTravelingAddDestination: 'Add destination',
  WhereAreYouTravelingRemoveDestinationAria: 'Remove destination {{country}}',
  whereAreYouTravelingGuidanceTitle: 'Important Information',
  mixedDestinationsTitle: "Travelling overseas and within Australia? You're covered",
  whereAreYouTravelingStopGuidance:
    "No need to select Australia if you're going overseas, your international policy covers it (limits apply). Stopovers under 48 hours are also automatically included.",
  mixedDestinationsWarning:
    'When you are travelling both domestically and internationally on a trip, you are covered under your international policy (Limits apply).\n' +
    'We’ve removed Australia from your Destination selection but don’t worry, you’re covered from the time you leave home.',
  whereAreYouTravelingPickedTitle: 'I’m travelling to',
  whenAreYouTravelingTitle: 'When are you travelling?',
  back: 'Back',
  previous: 'Previous',
  backStep: 'Back to previous step',
  customer: {
    newOrExistingCustomerQuestion: 'Have you already purchased a passport card?',
    newOrExistingCustomerText:
      'If you have previously purchased a travel policy abroad with us, we can help you faster..',
    newCustomerAnswer: 'No',
    existingCustomerAnswer: 'Yes',
    newCustomerText: 'This is the first time',
    existingCustomerText: 'I have purchased from you before',
    newCustomerTextAria: "No, I haven't purchased travel policy from passportcard before",
    existingCustomerTextAria: 'Yes, I have purchased travel policy from passportcard before',
    footerTextTitle: 'When can you not purchase insurance?',
    footerTextRule0: 'After you have already left Israel',
    footerTextRule1: 'If you intended to take off from another country',
    footerTextRule2: 'If the purpose of the trip is to receive treatment or medical advice abroad'
  },
  agentExistingPage: {
    title: 'Purchasing a policy on behalf of an agent',
    newOrExistingAgentQuestion: 'Has the customer made a purchase in the past? (Existing Customer)'
  },
  question: 'Question',
  preExCharge: {
    title: `Medical Premium`,
    description:
      'We have reviewed your answers to our Health Screening and added an additional premium to your quote based on your responses.\n\nMedical Premium {{price}}'
  },
  healthDeclaration: {
    healthScreening: {
      title: 'Health Screening',
      subtitle: 'Please answer the following questions for all travellers',
      checkboxesText: 'Please select all travellers affected by this condition',
      accpetanceCriteria1:
        'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately.',
      accpetanceCriteria2:
        'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately.'
    },
    medicalAssessment: {
      title: 'Medical Assessment',
      subtitle: 'Please answer the following questions for each listed traveller below',
      accpetanceCriteria1:
        'Based on the information provided, all travellers are covered for their pre-existing health conditions.',
      accpetanceCriteria2:
        'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately.'
    },
    title: 'Health Screening',
    subtitle: 'Please answer the following questions for all travellers.',
    text: 'We will automatically cover you for many pre-existing health conditions but we need you to answer the following questions. For some more serious or recent health conditions, we may need to ask you a few more questions to make sure you have the right cover for your trip.',
    agreement:
      "I agree to the <a href='#' id='candidateStatement'>candidate statement</a> and confirm that I have read and understood the <a href='#' id='termsAndConditions'>terms of use</a> and <a href='#' id='privacyPolicy'>privacy policy</a> through the website.",
    choiceQuestionLabel: 'Pick answer to question: {{question}}',
    questionAssessment:
      'We have a few more questions for you to complete as part of the Medical Assessment to make sure you are covered, and in some cases we may need to talk to you but we will let you know and will contact you within 1 business day.',
    questionAssessmentTitle: 'Medical Assessment',
    footerText1:
      'Based on the information provided, all travellers are covered for their \n' +
      'pre-existing health conditions.\n' +
      'Details cannot be edited after submission and proceeding to the next step.',
    footerText2:
      'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately. Details cannot be edited after submission.'
  },
  Yes: 'Yes',
  No: 'No',
  chooseQuestion: 'Choose a question',
  currentSelectionAriaLabel: 'current selection {{value}}',
  destinationIsAlreadyInYourTravelList: 'The destination is already in your travel list',
  destinationAlreadyRemovedFromYourTravelList:
    'The destination has already been removed from your travel list, try refreshing the page',
  backButtonText: 'Back',
  covers: {
    priceDetail: 'per day passenger',
    leaveCaption: 'Leave',
    removeCaption: 'Remove',
    popUpButton: 'details',
    included: 'Included',
    title: 'The basic cover package',
    price: 'Price',
    subTitle: 'Our basic insurance package includes four covers',
    itemsCounterLabel: 'Items',
    itemsCounterSingleLabel: 'One item',
    itemsSelectionLimitSubTitle:
      'You can select up toThe amount of items to cover is limited by the number of passengers',
    startDateAlt: 'Cover start date',
    endDateAlt: 'Cover end date',
    pdsLink: `See the <a href="{{pdsLink}}" target="_blank" id="pdsLink">PDS</a> for full details.`,
    basicCard: {
      title: 'The base components',
      details:
        'The basic insurance components that will ensure a responsible trip. Includes third party liability coverage and locating, search and rescue. These components can be changed by clicking the Detail button.',
      subCardTitle: 'The base components',
      subCardDetails:
        'The basic insurance components that will ensure a responsible trip. Includes third party liability coverage and locating, search and rescue. These components can be changed by clicking the Detail button.',
      continueNextStep: 'Continue to next step, Additional covers'
    },
    basicCoverMoreDetails: 'More details of {{cover}}',
    basicDetailPopUp: {
      title: 'Removable Basic Covers',
      subTitle: 'What does it include?',
      yearPeriodicSubtitle:
        'Cancellation and shortening of a trip for medical reasons, including coverage for epidemic scenarios',
      basicCovers: 'Basic covers',
      description: 'Basic covers for all travellers, for the entire travel period.',
      descriptionButtonText: 'View the policy booklet',
      secondSubTitle: 'Removable Basic Covers',
      yellowContent: {
        title: 'Highly Recommended to Keep These Covers',
        text: 'Important Information! This cover is defined as the default option as part of the basic package by the Ministry of Finance - Capital Market Division - Insurance Supervision. Removing this cover is not recommended due to the great importance of locating and rescuing insured persons abroad in extreme cases that may, God forbid, occur.'
      },
      additionalQuestion:
        'Do you have a close family member who visited the emergency room or was hospitalized in the last six months?',
      notRemovable: 'Not removable',
      removable: 'Removable'
    },
    basicCoversDescriptionText: {
      accidentCover: 'פיצוי כספי בגין מוות, נכות או שברים כתוצאה מתאונה',
      luggageCover: 'כיסוי של עד $2500 לעיכוב, אובדן או גניבת מזוודה',
      tripCancellationCover: 'ביטול או קיצור נסיעה מסיבות רפואיות, כולל כיסוי לתרחישי מגיפה',
      personalAccidentAdditionalText: 'לא יכוסה מקרה ביטוח אשר אירע עקב רכיבה על רכב דו-גלגלי, בין כנהג ובין כנוסע'
    },
    coversListTitle: 'Choose the covers you want to keep',
    detailPopUpContinueButton: 'Save and continue',
    coverDescriptionHeader: 'Whats included',
    readLess: 'Read less',
    readMore: 'קרא עוד',
    moreDetails: `לפרטים נוספים`,
    startDate: 'Start Date',
    endDate: 'End Date',
    optionalCovers: {
      recommendedCoversTitle: 'Complimentary covers',
      historicalCoversSubTitle: "Covers you've purchased in the past",
      tripCoversSubTitle: 'Recommended covers for this trip',
      extraCoversTitle: 'Choose Extra covers',
      additionalCoversTitle: 'Extra covers',
      optionalCoverSelect: 'Checkbox optional cover {{cover}}',
      optionalCoverMoreDetails: 'More details optional cover {{cover}}',
      continueToNextStep: 'Continue to next step, travellers details',
      heverCoverSubtitle: 'Included covers for "Hever" policy',
      yearlyOptionalCoverSubtitle: 'Covers that can be added',
      yearlyIncludedCoverSubtitle: 'Included covers'
    },
    coverLimits: {
      coverLimitTitle: 'Trip Cancellation Cover',
      coverLimitDescription:
        'Choose an amount to cover you for pre-paid expenses if you cancel or change your trip due to unforeseen circumstances, before leaving home.',
      coverLimitPlaceholder: 'Cover Limit',
      coverLimitLabel: 'Select a limit to cover your trip cancellation costs',
      excessAmountTitle: 'Set your Excess amount',
      excessAmountDescription:
        'Overseas medical claims, delayed luggage or theft of cash never attract an excess. The excess amount you choose applies only to the remaining sections of cover.',
      excessAmountPlaceholder: 'Excess Amount',
      excessLabel: 'Set your excess amount'
    },
    valuableItems: {
      headerTitle: 'Which items would you like to add?',
      title: 'Valuable items',
      description:
        'Coverage of up to $2,000 for theft of items from the list below. Covers can be purchased according to the number of passengers.',
      coverItemPricePerDayLabel: 'Day price per device:',
      valuableItemCoverPricePerDayLabel: 'Day price per item:',
      incrementAriaLabel: 'Increment unit',
      decrementAriaLabel: 'Decrement unit',
      itemSelectedArialLabel: 'Item selected {{item}}'
    },
    EntertainmentExpensesCover: {
      title: 'Entertainment card expenses',
      descriptionHeader: 'What does it include?',
      subtitle: 'Day price per device:',
      itemsTitle: 'Coverage details',
      coverPriceSubtitle: 'Price Per Insured',
      contentTitle: 'How many tickets would you like to add?',
      yellowCardTextDesktop: 'The amount of tickets to cover is limited by the number of passengers'
    }
  },
  representive: {
    representiveName: 'Sapir',
    header: 'Jeeping in Australia',
    description:
      'Most travellers to Australia do not miss the opportunity to go on jeep trips in the field. Any trip that is not on a paved road requires coverage of outdoor activities and extreme sports, even for those who are not the driver.'
  },
  TripDetails: 'Trip Details',
  deviceModel: 'Device Model ',
  CoverageSelection: 'Coverage Selection',
  TravelersDetails: 'Travellers Details',
  PurchaseCompletion: 'Purchase Completion',
  Reminders: 'Reminders',
  Billing: 'Billing',
  ComplementaryBenefits: 'Complementary Benefits',
  BasicCoverageSelection: 'Basic Coverage Selection',
  AdditionalCoverageSelection: 'Additional Coverage Selection',
  HealthDeclaration: 'Health Declaration',
  billingPage: {
    existingCardsTitle: 'Choosing Payment Method',
    singleCardTitleOption: 'Credit Card Saved In The System',
    multipleCardsTitleOption: 'Selection From Saved Credit Cards',
    newCardTitle: 'Adding payment method',
    policyDetails: 'Policy Details',
    subtitleDesktop:
      'Choosing the payment method The charge will be made in AUD according to the current representative exchange rate for today',
    subTitle:
      'The charge will be made in Shekels according to the current exchange rate on the day the policy is issued',
    plusIcon: 'plus icon',
    toCardList: 'Pay with existing credit card',
    checkboxText:
      'I understand that my details will be used for sending email notifications about updates and benefits in PassportCard services and I agree to that',
    cardHolder: 'Card holder',
    lastNamePlaceholder: 'Last Name',
    firstNamePlaceholder: 'First Name',
    idPlaceholder: 'ID Number',
    submitBtn: 'Proceed to Secure Purchase',
    iframeTitle: 'Add new card form',
    numberOfPayments: 'Number of payments',
    numberOfPaymentsAriaLabel: 'Select number of payments',
    benefits: {
      title: 'Benefits:',
      first: 'Cancellation option at any time, up to 4 hours before departure',
      second: 'You can change dates and update the policy through the personal area on the website or by calling 9912*'
    },
    cards: {
      title: 'Other Saved Cards',
      number: 'Card Number',
      expiredDate: 'Expiration Date',
      cardDetailsAriaLabel: 'Card Type: {{cardType}}, last 4 digit: {{cardNumber}}, Expiration Date: {{expiredDate}}',
      addNewCard: 'Pay with a New Credit Card',
      cardLabel: 'Credit card saved in the system'
    },
    cardsLogosAlt: 'Visa, Master Card, Diners, American Express logos',
    disclaimer:
      'Payment details are securely stored as outlined in the <a href="#" id="privacyPolicy">privacy policy</a> of the company.'
  },
  ReadMore: 'Read More',
  ReadLess: 'Read Less',
  YearlyRateText: 'Yearly rate:',
  PeriodicCovers: {
    dateRangeTitle: 'Coverage date range',
    dateRangeTitleCarRental: 'Coverage date range car rental',
    dateRangeTitleAriaLabel: 'Edit date range',
    fullTravelRangeTitle: 'The entire travel range',
    partialTravelRangeTitle: 'Partial travel range',
    dateRangeSelectionTitle: 'Range selection',
    errorMsg: 'There is an error in selecting the dates'
  },
  carRentalCover: {
    mainTitleInMobile: 'Car rental cover',
    mainTitleInDesktop: 'Cover details',
    subtitle: 'What does it include?',
    DailyRateText: 'Daily rate:',
    description:
      'Whether you are renting a private car or a caravan, it is recommended that you equip yourself with the "rental car deductible cancellation" extension. This supplement will prevent you from unplanned expenses due to accidental damage to the rented vehicle. The liability limit ceiling in this coverage is $1,500, and involves a $50 deductible. If coverage is needed for driving a Jeep on an unpaved road, contact the sales center for dedicated coverage by calling *9912',
    details: {
      deductibleTypeTitle: 'Type of rental car',
      typeOfCarToCoverText: 'Car to cover',
      roadCar: 'Rental car',
      offRoadCar: 'Jeep',
      carDriverTitle: 'Who will drive the car?',
      carDriverDescription: 'This coverage can be added for one participant only'
    }
  },
  StandardCovers: {
    DescriptionHeader: 'What Does It Include?',
    TheftCoverage: 'Theft Coverage {{amount}}',
    CoverageAdditionNotice:
      'Please note, this coverage can be added for each insured person separately and for a partial period.',
    CoverWho: 'Whom do we cover?',
    ExtremeSport: {
      Title: 'Outdoor Activities and Extreme Sports',
      ItemsTitle: 'Who Does It Cover?',
      DailyRateText: 'Price Per Insured Per Day:',
      ContentNotice: '',
      DailyRateIncrement: '',
      DailyRateIncrementDesktop: ''
    },
    LaptopTablet: {
      Title: 'Coverage for Laptop or Tablet',
      ItemsTitle: 'For Whom Would You Like to Insure?',
      DailyRateText: 'Price Per Device Per Day:',
      ContentNotice: '',
      DailyRateIncrementDesktop: '',
      DailyRateIncrement: ''
    },
    Camera: {
      Title: 'Camera Coverage',
      ItemsTitle: 'Who to Cover the Device For?',
      DailyRateText: 'Price Per Device Per Day:',
      ContentNotice: '',
      DailyRateIncrementDesktop: '',
      DailyRateIncrement: ''
    },
    Cellular: {
      Title: 'Mobile Phone Coverage',
      ItemsTitle: 'Who to Cover the Device For?',
      DailyRateText: 'Price Per Device Per Day:',
      ContentNotice: '',
      DailyRateIncrementDesktop: 'Double compensation with a daily difference of 50 Cents',
      DailyRateIncrement: 'Daily difference of 50 Cents',
      firstPriceOption: 'עד $800',
      secondPriceOption: 'עד $1600'
    },
    WinterSport: {
      Title: 'Winter Sports Coverage',
      ItemsTitle: 'Additional Coverage Details',
      DailyRateText: 'Price Per Insured Per Day:',
      ContentNotice: '',
      DailyRateIncrementDesktop: '',
      DailyRateIncrement: ''
    },
    ProfessionalCompetitiveSport: {
      Title: 'Professional and Competitive Sports Coverage',
      ItemsTitle: 'Additional Coverage Details',
      DailyRateText: 'Price Per Insured Per Day:',
      ContentNotice: '',
      DailyRateIncrementDesktop: '',
      DailyRateIncrement: ''
    },
    MilitaryCover: {
      Title: 'Military Cover - Trip Cancellation Due to Operational Activity',
      ItemsTitle: 'Additional Coverage Details',
      DailyRateText: 'Price Per Insured Per Day:',
      ContentNotice: '',
      DailyRateIncrement: '',
      DailyRateIncrementDesktop: ''
    }
  },
  FormDeclarations: {
    Section1: `All travellers are Australian Citizens or hold valid visas to live, work or study in Australia and intend to return to Australia during the period of insurance.`,
    Section2: `I confirm that I have read and understood the Combined <a href="{{pdsLink}}" target="_blank" id="fsgAndPds" class="link-text">FSG and PDS</a> and <a href="{{travelAlertsLink}}" target="_blank" id="travelAlerts" class="link-text">Travel Alerts</a>. I confirm that I understand my <a href="{{dutyOfDisclosureLink}}" target="_blank" id="dutyOfDisclosure" class="link-text">Duty to take reasonable care</a> not to make a misrepresentation and I have answered all questions honestly and accurately. I confirm that I have read, understand and agree to the terms of the <a href="{{privacyNoticeLink}}" target="_blank" id="privacyNotice" class="link-text">Privacy - Collection Statement </a> and the <a href="{{privacyPolicyLink}}" target="_blank" id="privacyPolicy" class="link-text">Privacy Policy</a>. Where I have provided personal information about any other person I have their consent to do so.`,
    Section3: `I consent to receiving marketing information about other PassportCard products and services. I acknowledge I can opt out at any time (optional).`,
    Disclaimer: `The PassportCard is subject to its own <a href="{{termsAndConditionsLink}}" target="_blank" id="termsAndConditions" class="link-text">Terms and Conditions</a>. In the event of an approved claim you do not have to use the PassportCard if you prefer to pay for any expenses yourself and be reimbursed later.`
  },
  COLLINSON: {
    LOGO_IMAGE: 'תמונת לוגו פספורטכארד',
    CLOSE_POPUP: 'סגירת חלון פופאפ',
    ATTENTION: 'שים לב',
    IFRAME: 'דף פרטי טיסה',
    IDENTIFICATION_STAGE: {
      TITLE_1: 'הטיסה התעכבה מעל',
      TITLE_2: '90 דקות?',
      TITLE_3: 'טוב שיש לך פספורטכארד',
      SUB_TITLE_1: 'הלקוחות שלנו ממתינים לטיסה בכיף!',
      SUB_TITLE_2: 'הירשמו ללא עלות לשירות PassportCard Flight Delay',
      PERSONAL_ID_LABEL: 'תעודת זהות',
      PERSONAL_ID_PLACEHOLDER: 'הזינו מספר תעודת זהות',
      INVALID_PERSONAL_ID: 'מספר תעודת הזהות אינו תקין, אנא נסו שוב',
      NEXT_BUTTON: 'המשך',
      AIRPLANE_ICON_ALT: `מטוס`,
      LOGIN_MAIN_TITLE: `הטיסה התעכבה מעל 90 דקות? \nטוב שיש לך פספורטכארד!`,
      LOGIN_SUB_TITLE_DESKTOP: `הלקוחות שלנו ממתינים לטיסה בכיף! \nהירשמו ללא עלות לשירות PassportCard Flight Delay`,
      LOGIN_SUB_TITLE: `הלקוחות שלנו ממתינים לטיסה בכיף! \nהירשמו ללא עלות לשירות\nPassportCard Flight Delay`,
      TERMS_CONDITIONS: `השירות ניתן באמצעות ספק שירותים, בכפוף <a href="#" id="collinsonTermsAndConditions">לתנאי השימוש</a> של שירות PassportCard Flight Delay\n.`,
      DETAILS: {
        LOUNGES: 'השירות פעיל בכ-1,200 טרקלינים ברחבי העולם ביותר מ-650 שדות תעופה.',
        LOUNGES_NUMBER: `מספר הטרקלינים עשוי להשתנות מעת לעת ללא הודעה מראש.`
      }
    },
    OFFER: {
      TITLE: 'רגע לפני שנרשמים חשוב לדעת',
      SUB_TITLE: 'PassportCard Flight Delay\n המתינו לטיסה בכיף!\n במקרה של עיכוב מעל 90 דקות',
      SUB_TITLE_DESKTOP: 'PassportCard Flight Delay\n המתינו לטיסה בכיף! במקרה של עיכוב מעל 90 דקות',
      TEXT_1: 'השימוש בשירות מותנה בהרשמה מראש של עד 6 שעות לפני הטיסה, שלכם ושל בני המשפחה המבוטחים בפוליסה.',
      TEXT_2: 'השירות פעיל בכ-1,200 טרקלינים ברחבי העולם ביותר מ-650 שדות תעופה.',
      LIST_TITLE: 'דגשים חשובים:',
      LIST_1:
        'השירות מבוסס על מנועי מעקב הטיסות הבינלאומיות, אם שינוי זמן הטיסה לא עודכן ע"י חברת התעופה, לא ניתן לעקוב אחר הטיסה ולהנפיק שובר כניסה לטרקלין.',
      LIST_2: 'בטרמינל 1 נתב"ג אין טרקלין הנכלל בשירות.',
      LIST_3: 'יש טיסות שאינן נכללות בשירות, לרוב אלו טיסות שכר (צרטר).',
      LIST_4: 'חלק משדות התעופה וחברות התעופה אינם נכללים בשירות.',
      LIST_5: `בחלק משדות התעופה לא קיים טרקלין. לחיפוש ומידע על הטרקלינים הכלולים בשירות  <a href="#" id='collinsonLoungeList'>לחצו כאן</a>.`,
      LIST_6: 'במקרה של עיכוב טיסה מעל 90 דקות יש להתחבר לאינטרנט לקבלת שובר כניסה לטרקלין.',
      MORE: `לשאלות נוספות והסבר\n<a href="#" id='collinsonClarifications' class="body-large-link">לחצו כאן</a>`,
      MORE_DESKTOP: `לשאלות נוספות והסבר <a href="#" id='collinsonClarifications' class="body-xlarge-link">לחצו כאן</a>`,
      MORE_VIDEO: `לשאלות נפוצות וסרטון הסבר <a href="#" id='collinsonExplanationVideo'">לחצו כאן</a>`,
      SMALL_LIST_1: 'הכניסה לטרקלין מותנית בהצגת השובר שקיבלת, בצירוף דרכון. הכניסה לטרקלין הינה על בסיס מקום פנוי.',
      SMALL_LIST_2: 'השירות ניתן באמצעות ספק שירותים, בכפוף',
      SMALL_LIST_3: 'של שירות PassportCard Flight Delay ("השירות").',
      TERMS_CONCENT: 'הנני מאשר/ת ומסכימ/ה כדלקמן:',
      TERMS_SPAM: `אני מאשר/ת קבלת דואר שיווקי מטעם קבוצת פספורטכארד.
אני מסכים/ה לקבל הצעות שיווקיות בתחום הביטוח, שירותים פיננסיים ומוצרים אחרים של חברות קבוצת פספורטכארד ו/או מי מטעמן, מכל אחת מחברות הקבוצה, לרבות על בסיס פילוח והשתייכותי לאפיון מסוים.
ידוע לי שאוכל לבקש את הסרתי בכל עת באמצעות שליחת בקשה לחברה הרלוונטית בקבוצה, באמצעים שיפורסמו על ידה בעת משלוח החומר הפרסומי.`,
      TERMS_SPAM_DESKTOP: `אני מאשר/ת קבלת דואר שיווקי מטעם קבוצת פספורטכארד.
אני מסכים/ה לקבל הצעות שיווקיות בתחום הביטוח, שירותים פיננסיים ומוצרים אחרים של חברות קבוצת פספורטכארד ו/או מי מטעמן, מכל אחת מחברות הקבוצה, לרבות על בסיס פילוח והשתייכותי לאפיון מסוים.
ידוע לי שאוכל לבקש את הסרתי בכל עת באמצעות שליחת בקשה לחברה הרלוונטית בקבוצה, באמצעים שיפורסמו על ידה בעת משלוח החומר הפרסומי.\n`,
      TERMS_SPAM_SHORT: `אני מאשר/ת קבלת דואר שיווקי מטעם קבוצת פספורטכארד .`,
      TERMS_APROVAL: `הנני מאשר/ת ומסכים/ה כי: מידע אודותי יועבר לספק השירות לצורך קבלת השירות. קראתי, הבנתי והסכמתי <a href="#" id="collinsonPrivacyNotes">למדיניות הפרטיות</a> ו<a href="#" id="collinsonTermsAndConditions" class="link-text">תנאי השימוש</a> מסירת מידע אישי, שמירתו והעברתו תעשה בהתאם ובכפוף למדיניות הפרטיות.\n ידוע לי, כי הרשמה לשירות מותנית בקבלת הסכמתי כאמור`,
      TERMS_APROVAL_DESKTOP: `הנני מאשר/ת ומסכים/ה כי: מידע אודותי יועבר לספק השירות לצורך קבלת השירות. קראתי, הבנתי והסכמתי <a href="#" id="collinsonPrivacyNotes">למדיניות הפרטיות</a> ו<a href="#" id="collinsonTermsAndConditions" class="link-text">תנאי השימוש</a> מסירת מידע אישי, שמירתו והעברתו תעשה בהתאם ובכפוף למדיניות הפרטיות. ידוע לי, כי הרשמה לשירות מותנית בקבלת הסכמתי כאמור`
    },
    IDENTIFICATION_STAGE_POPUP: {
      CLOSE: 'סגור',
      PURCHASE: 'לרכישה',
      TRY_AGAIN: 'נסו מחדש'
    },
    ERROR: {
      TITLE_1: 'לא הצלחנו להשלים את תהליך ההרשמה',
      TITLE_2: 'בטוח שהפעלת את פוליסת הנסיעות שלך?',
      TEXT: `<span class="headline5-main-title">בטוח שהפעלת את פוליסת הנסיעות שלך?</span>
על מנת לקבל שירות זה, יש לוודא כי תעודת הזהות שהוזנה משוייכת לפוליסה פעילה.
במידה ואים לכם פוליסה פעילה, תוכלו לרכוש פוליסה חדשה בלחיצה על כפתור “לרכישת פוליסה”.`,
      CONTINUE_BUTTON_TEXT: 'לרכישת פוליסה',
      RETRY_TEXT: 'נסו שוב',
      API_ERROR_TITLE: 'אופס, משהו השתבש',
      API_ERROR_TEXT: 'אנא נסו שוב בעוד מספר דקות'
    },
    OTP_STAGE: {
      TITLE_1: 'הזינו את הקוד שקיבלתם',
      TITLE_2: 'בהודעת ה-SMS',
      SUB_TITLE: 'קוד אישור נשלח לטלפון שמספרו',
      TOKEN_LABEL: 'קוד אישור',
      TOKEN_PLACEHOLDER: 'הזינו קוד אישור',
      INVALID_TOKEN: 'קוד האישור אינו תקין, אנא נסו שוב'
    },
    BANNER: {
      TEXT: 'להרשמה לשירות PassportCard Flight Delay בחינם'
    },
    EXPIRED: {
      TITLE: 'ההרשמה לשירות הסתיימה...',
      SUB_TITLE: 'נתראה בפעם הבאה!',
      TO_HOME: 'לאתר הבית'
    },
    ADDITIONAL: {
      TITLE: 'לשאלות נפוצות וסרטון הסבר',
      LINK: 'לחצו כאן',
      LIST_1: 'השירות פעיל בכ-1,200 טרקלינים ברחבי העולם ביותר מ-650 שדות תעופה.',
      LIST_2: 'מספר הטרקלינים עשוי להשתנות מעת לעת ללא הודעה מראש.',
      LIST_3: 'השירות ניתן באמצעות ספק שירותים, בכפוף',
      TERMS: 'לתנאי השימוש',
      TERMS_2: 'של שירות PassportCard Flight Delay.'
    },
    PRIVACY: 'מדיניות הפרטיות',
    SUBMIT: 'אישור ',
    TERMS: 'תנאי השירות',
    AND: 'ול'
  },
  COLLINSON_DIALOG: {
    TITLE: 'PassportCard Flight Delay',
    CTA: 'לרישום לחצו כאן',
    DISCLAIMER: 'השירות מחייב רישום מראש'
  },
  ReminderCard: {
    title: 'It looks like you have not chosen the following covers:',
    informationSingleCoverUpperText: 'We recommend that you add the following cover to your policy:',
    informationMultipleCoverUpperText: 'We recommend that you add the following covers to your policy:',
    baggageCoverageBulletPoint: 'Baggage coverage is the coverage with a particularly high redemption rate.',
    cancellationShorteningCoverageBulletPoint:
      'Cancellation and trip shortening coverage - after we learned that there are unexpected and surprising cases. We recommend leaving it as well.',
    coverTitleQuestion: 'Which coverages would you like to add?',
    travelerPricePerDay: 'per day passenger',
    reminderOptionLabel: 'Reminder to pick cover {{reminder}}'
  },
  preExDialog: {
    title: 'Just before we continue...',
    description: 'Inquiry regarding the medical report - Coordination.',
    information:
      'In the medical questionnaire you filled out, you marked "No" for the question whether you are diagnosed with a chronic disease, take medication regularly, or have a disability percentage.',
    buttonText: 'Back to updating the medical questionnaire',
    subInformation:
      'In previous policies, you answered "Yes" to this question. Please update the medical questionnaire according to your condition.',
    talkWithRepresentativeButtonText: 'To speak with a representative.',
    popUpImage: 'dialog image'
  },
  SessionTimeout: {
    title: 'No activity detected...',
    description: 'We noticed that your time on the site is longer than usual. Would you like to continue the process?',
    continueButton: 'Continue to Purchase',
    backToHomeButton: 'Back to Home Page',
    popUpImage: 'dialog image'
  },
  IframeDialogTitle: {
    candidateStatement: 'הצהרת מועמד',
    privacyPolicy: 'מדיניות הפרטיות',
    termsAndConditions: 'תנאי השימוש',
    privacyPolicyRecaptcha: 'Privacy Policy Recaptcha',
    termsAndConditionsRecaptcha: 'Terms And Conditions Recaptcha',
    collinson: 'PassportCard Flight Delay',
    controlRoom: 'חדר המצב',
    voyeBenefit: 'הטבת שירות eSIM',
    accessibilityStatement: 'הצהרת נגישות',
    accessibilitySupportCompany: `WEB-A הנגשת אתרים, אפליקציות ומערכות מתקדמות`,
    mainWebsiteAccessibilityStatement: `main website`
  },
  calendar: {
    pickDestinationDateForScreenReader: 'Departure date picked, please pick destination date.',
    finishPickedForScreenReader: 'Return date picked, please move to the next step button by pressing tab.',
    travelPeriodPlaceholderText: 'Entire Travel Range',
    travelPeriodEditText: 'Range Selection',
    editBtnText: 'Edit',
    todayCellText: '',
    errorMsg: 'There is an error in selecting the dates'
  },
  calendarLabels: {
    calendarLabel: 'calendar',
    openCalendarLabel: 'Open calendar',
    closeCalendarLabel: 'Close calendar',
    prevMonthLabel: 'Previous month',
    nextMonthLabel: 'Next month',
    prevYearLabel: 'Previous year',
    nextYearLabel: 'Next year',
    prevMultiYearLabel: 'Previous multi years',
    nextMultiYearLabel: 'Next multi years',
    switchToMonthViewLabel: 'Change to month view',
    switchToMultiYearViewLabel: 'Change to year view'
  },
  expandLabel: 'Expand {{title}}',
  minimizeLabel: 'Minimize {{title}}',
  tripDates: {
    title: 'When are you leaving and when are you returning?',
    dateSelectionDepartureHeader: 'Select departure date',
    dateSelectionReturnHeader: 'Select return date',
    yearlyPolicydateSelectionHeader: 'Policy start date',
    dateSelectionDepartureSubHeader: '',
    dateSelectionReturnSubHeader: '',
    yearlyPolicySubHeader: '',
    summaryDays: '{{count}} days',
    summaryDay: 'One day',
    greatTimeAway: 'Includes your departure and return days',
    editNote: 'You can edit the values ​​by clicking "Edit"',
    fromDate: 'Departure',
    toDate: 'Return',
    editFromDate: 'Edit from date',
    editToDate: 'Edit to date',
    shortTerm: 'Daily policy',
    yearlyPolicy: 'Yearly policy',
    yearlyPolicyYellowCardText:
      'The policy end date is automatically calculated for 365 days. Please note - up to 30 days in a row for each trip with no limit on the number of trips.',
    errorPopUpHeader: 'Please note',
    annualTravelerCountExceeded:
      'The travellers composition is not suitable for this policy. In the annual plan, one insured can be updated in each policy.',
    annualTravelerAgeExceeded:
      'Annual policy is not suitable for ages 70 and above. One or more of the travellers exceeds the age limit.',
    noProductsAvailable: 'Based on the information provided, we cannot continue with the purchase.',
    errorPopUpButtonText: 'Update passengers list',
    errorPopUpAlternativeLinkText: 'Switch to daily policy'
  },
  QuoteOverview: {
    medicalQuestionnaireFooterNotice:
      'We have added coverage for your existing condition based on the answers provided in the medical questionnaire.',
    currencyNotice:
      'Charges will be made in Shekels according to the representative exchange rate on the policy issuance date.',
    discountNotice:
      'The price includes a 15% discount on the selected extensions (except for the basic policy and search and rescue extensions).',
    policyContentsHeader: 'Policy Contents',
    yourQuote: 'Your Quote',

    totalLabel: 'Total',
    paymentAmountDescription: 'Show details about payment amount.',
    includedLabel: 'Included',
    travelersCountLabel: {
      multiple: 'Travellers',
      single: 'One Traveller'
    },
    continueButton: 'Continue',
    Destinations: 'Destinations',
    destinationAltPrefix: 'Selected destination ',
    destinationsToggleOptions: {
      more: 'more destinations...',
      less: 'Show less'
    },
    brokerFee: {
      brokerFeeTitle: 'Broker Fee',
      brokerFeeSubtitle: 'Broker fee amount',
      brokerFeePlaceholder: '$ Enter fee (Excluding GST)',
      brokerFeeButton: 'Update Broker Fee'
    },
    emailQuote: {
      emailQuoteTitle: 'Email Your Quote',
      emailQuoteSubtitle: `We’ll email your quote to you.<br>Please see our <a href="{{url}}"  target="_blank" id="privacyPolicy">Privacy Policy.</a>`,
      emailQuoteInputLabel: 'Your Email',
      emailQuoteAlertTitle: 'Your quote has been emailed',
      emailQuoteAlertSubTitle: 'It should appear in your inbox within a couple of minutes.',
      emailQuoteButton: 'Email Quote'
    },
    SelectedCovers: {
      BasicCovers: 'Basic Covers',
      OptionalCovers: 'Optional Cover(s)',
      ActivityCovers: 'Activity Cover(s)',
      YourCover: 'Your Cover',
      AdditionalCovers: 'Additional Components',
      BasePackage: 'Base Package',
      YearlyBasePackage: 'Yearly Package',
      BaseCoverageNotice:
        'The base package includes coverage for search and rescue, and third-party liability, unless you chose to remove them'
    }
  },
  SuccessScreen: {
    confirmationTitle: 'You’re all insured!',
    confirmationSubtitle: 'On behalf of the PassportCard crew, we hope you have a pleasant trip.',
    policyNumberLabel: 'Policy Number',
    summaryOfCover: 'Summary of Cover',
    footerNotice: 'Your policy details have been sent to your email and mobile'
  },
  BenefitCard: {
    title: 'You deserve immediate benefits!',
    titleForAgentProccess: 'Your client deserve immediate benefits!',
    benefitCounter: 'Benefit {{index}} of {{total}}',
    cardsContent: {
      collinson: {
        benefitLink: 'collinson',
        title: 'PassportCard Flight Delay',
        description:
          'free access to hundreds of lounges worldwide in case of a flight delay of more than 90 minutes. The service is free and depends on pre-registration.',
        desktopImage: '/assets/images/DESKTOP_lounge.png',
        mobileImage: '/assets/images/MOBILE_lounge.png',
        desktopCoverImage: '/assets/images/COVER_DESKTOP_lounge.png',
        mobileCoverImage: '/assets/images/COVER_MOBILE_lounge.png',
        qrCode: '/assets/images/QR_lounge.png',
        buttonLabel: 'Register for free',
        agentEmailText: '',
        qrLabel: 'To register for the service, scan the QR code'
      },
      controlRoom: {
        benefitLink: 'controlRoom',
        title: 'Control Room',
        description:
          'Connection to the PassportCard control room, active 24/7, providing a wide range of important alerts in real-time and wherever you are in the world.',
        desktopImage: '/assets/images/DESKTOP_control_room.png',
        mobileImage: '/assets/images/MOBILE_control_room.png',
        desktopCoverImage: '/assets/images/COVER_DESKTOP_control_room.png',
        mobileCoverImage: '/assets/images/COVER_MOBILE_control_room.png',
        qrCode: '/assets/images/QR_control_room.png',
        buttonLabel: 'Download for free',
        agentEmailText: '',
        qrLabel: 'To download the app, scan the QR code'
      },
      voyeBenefit: {
        benefitLink: 'voyeBenefit',
        title: 'Free Esim Card',
        description:
          'Connection to the PassportCard control room, active 24/7, providing a wide range of important alerts in real-time and wherever you are in the world.',
        desktopImage: '/assets/images/DESKTOP_esim.png',
        mobileImage: '/assets/images/MOBILE_esim.png',
        desktopCoverImage: '/assets/images/COVER_DESKTOP_esim.png',
        mobileCoverImage: '/assets/images/COVER_MOBILE_esim.png',
        qrCode: '',
        buttonLabel: 'Download for free',
        agentEmailText: 'הקישור להטבה נשלח לכתובת דוא"ל:',
        qrLabel: 'To download the app, scan the QR code'
      },
      pfsBenefit: {
        benefitLink: 'voyeBenefit',
        title: 'Free Esim Card',
        description:
          'Connection to the PassportCard control room, active 24/7, providing a wide range of important alerts in real-time and wherever you are in the world.',
        desktopImage: '/assets/images/DESKTOP_esim.png',
        mobileImage: '/assets/images/MOBILE_esim.png',
        desktopCoverImage: '/assets/images/COVER_DESKTOP_esim.png',
        mobileCoverImage: '/assets/images/COVER_MOBILE_esim.png',
        qrCode: '',
        buttonLabel: 'Download for free',
        agentEmailText: '',
        qrLabel: 'To download the app, scan the QR code',
        pfsBenefitExtended: {
          title: 'יעניין אותך לחסוך עמלות ולקבל החזר מע״מ?',
          subTitle: 'חסכון מוערך על סמך ממוצע נוסעים כמוך',
          destination: 'יעד',
          travelersAmount: 'נוסעים',
          tripLength: 'משך',
          howItWorks: 'איך זה עובד?',
          howItWorksDescription:
            'מעכשיו, כרטיס הפספורטכארד שלך יכול לשמש אותם גם להוצאות הנסיעה, ולאפשר לך ליהנות ממספר הטבות ייחודיות:',
          continueBtn: 'לקבלת פרטים נוספים',
          yellowCard: 'יש לך הזדמנות לחסוך ₪{{amount}}',
          subTitleC: 'זה הסכום שבאפשרותך לחסוך',
          textC: 'החישוב מבוסס על נוסעים ליעד ומשך זמן דומה'
        },
        pfsFullPageExplanatory: {
          title: 'איך מפעילים את השירות?',
          subTitle: 'תוך דקה תוכלו להירשם לשירות.',
          list1: 'משייכים את הפספורטכארד לאחד מכרטיסי האשראי שברשותך',
          list2: 'מעדכנים את פרטי הכתובת',
          list3: 'מזינים פרטים לפתיחת שירות החזרי מע״מ',
          list4: 'מבצעים במהלך הנסיעה את הרכישות דרך הפספורטכארד ',
          button: 'להרשמה לשירות'
        },
        pfsBenefitExtendedList: {
          expenseTracking: {
            title: 'מעקב הוצאות חכם בחו״ל',
            longTitle: 'מעקב הוצאות חכם בחו״ל',
            description: 'משלמים על כל ההוצאות בכרטיס אחד וניהנים ממעקב הוצאות להתנהלות נוחה וחכמה.',
            icon: '/assets/images/pfs_expenseTracking.png'
          },
          feesEconomy: {
            title: 'חסכון בעמלות',
            longTitle: 'חסכון בעמלות המרה ועמלות כפולות',
            description: 'חוסכים בעמלות המרה, עמלות כפולות ועמלות נלוות שקיימות בכרטיסי האשראי האחרים.',
            icon: '/assets/images/pfs_feesEconomy.png'
          },
          vatRefund: {
            title: 'החזרי מע״מ',
            longTitle: 'החזרי מע״מ בקלות (במדינות שיש אפשרות)',
            description: 'הזדמנות לקבלת החזר מע"מ במהירות ובקלות, בלי בירוקרטיה מיותרת.',
            icon: '/assets/images/pfs_vatRefund.png'
          }
        }
      }
    }
  },
  contactUs: {
    title: 'Just before we continue...',
    description: 'Inquiry regarding the medical report - Coordination.',
    information:
      'In the medical questionnaire you filled out, you marked "No" for the question whether you are diagnosed with a chronic disease, take medication regularly, or have a disability percentage.',
    buttonText: 'Please contact me.',
    alternativeButtonText: 'Home Page',
    subInformation:
      'In previous policies, you answered "Yes" to this question. Please update the medical questionnaire according to your condition.',
    talkWithRepresentativeButtonText: 'To speak with a representative.',
    popUpImage: 'dialog image',
    formTitle: 'Contact info',
    namePlaceholder: 'First Name',
    surnamePlaceholder: 'Last Name',
    emailPlaceholder: 'Email',
    phonePlaceholder: 'Phone Number',
    formReceived: 'Form received',
    formCompletedText: 'Our representatives will be in touch with you as soon as possible'
  },
  Alerts: {
    PregnancyCoverage: {
      Title: 'Adjusting Coverages for Pregnancy',
      Description: '',
      Information:
        'שמחנו לשמוע ואנחנו מאחלים הריון בריא וקל ככל האפשר. בהתאם לתנאי הפוליסה יש פעילויות מסוימות אותן אנחנו לא מכסים עבור נשים בהריון ולכן הסרנו עבורך את הכיסויים התואמים ולא יבוצע חיוב עבורם.',
      SubInformation: 'כיסויים שהוסרו הם: {{covers}}'
    },
    CardBlocked: {
      Title: 'Your Credit Card is Blocked',
      Description: 'Three failed billing attempts',
      Information:
        "To proceed with billing, you can contact our call center or check what's up with your card at the credit card company.",
      SubInformation: ''
    },
    isSearchAndRescueCoverAllowed: {
      Title: 'Expanding search and rescue',
      Description: '',
      Information:
        'It is important to know that the purchase of search and rescue coverage is not possible in the selected destination, therefore the extension of the rescue has been removed from the policy. For more details, you can contact our sales center at *9912.',
      SubInformation: ''
    },
    isSearchAndRescueDisallowedCountries: {
      Title: 'הרחבת איתור חיפוש וחילוץ',
      Description: '',
      Information:
        'Please note that the policy only covers stays in countries with which Israel has diplomatic relations and are not in an unstable security or political situation, denying the insurance company the possibility of granting you the coverage you purchased. Also, the policy does not cover a stay in the territories of the Palestinian Authority. Please note that the selected destination includes countries that are excluded from coverage according to the extension to search and rescue expenses. Below is the list of excluded countries:',
      SubInformation: '{{disalowedCountries}}'
    },
    isSearchAndRescueCoverDisabled: {
      Title: 'Expanding search and rescue',
      Description: '',
      Information:
        'Please note, this coverage is defined as part of the default as part of the basic package by the Ministry of Finance - Capital Market Division - Insurance Supervision. Removing this coverage is not recommended due to the great importance of locating and rescuing policyholders abroad.',
      SubInformation: ''
    }
  },
  restrictionsCover: 'You cannot add {{coverName}} at the same time as {{restrictedCoverName}}',
  retryCardError: {
    cardErrorTitle: 'There is a problem with the credit card',
    cardErrorInformation:
      'Payment method details must be entered correctly or an alternative payment method must be entered',
    errorCardContinueButton: 'Continue',
    creditCardAlt: 'Problem with credit card'
  },
  charactersBoxInput: {
    onlyNumbersAllowed: 'Only numbers are allowed',
    allCharactersAllowed: 'All characters are allowed'
  },
  accessibilityStatement: 'Accessibility Statement',
  recaptchaStatement: "The site is secured using reCAPTCHA subject to Google's privacy policy and terms of use",
  optionalCoverRestrictionPopup: {
    title: 'Cover matching for',
    information:
      'Cover for winter sports cannot be made at the same time as personal accident cover. If skiing, snowboarding, snow sledding, figure skating, or ice-cream fighting are expected as part of your trip, you will need to replace your personal accident coverage with winter sports coverage.',
    submitButtonText: 'Remove personal accidents and activate this cover',
    alternativeButtonText: 'Do not activate this cover'
  },
  userLoginLegalText: 'בהתחברות כמשתמש קיים ימולאו אוטומטית הפרטים\nהאישיים בלבד ללא מידע על מצב בריאותי',
  userLoginLegalTextDesktop: 'בהתחברות כמשתמש קיים ימולאו אוטומטית הפרטים האישיים בלבד ללא מידע על מצב\nבריאותי.',
  splashScreen: {
    descriptionDesktop: 'הינכם מועברים לרכישת ביטוח נסיעות\nפספורטכארד באמצעות',
    description: 'הינכם מועברים לרכישת ביטוח נסיעות\nפספורטכארד באמצעות סוכנות',
    agent: 'סוכנות',
    activeWith: 'Active with'
  },
  agentLoginPage: {
    title: 'Agent Login',
    subtitle: 'You must identify yourself in the same way as the identification in the agent interface',
    mendatoryText: 'All fields are mendatory',
    usernameOrEmailPlaceHolderText: 'Email',
    phoneNumberPlaceHolderText: 'Mobile phone - to receive an SMS for verification',
    agentError: 'The username/email does not exist',
    agentIdTitle: 'We would be happy to identify the customer',
    agentIdQuestion: 'Customer ID number',
    agentLoginLegalText: '  בזיהוי לקוח קיים ימולאו אוטומטית הפרטים\nהאישיים בלבד ללא מידע על מצב בריאותי',
    agentLoginLegalTextDesktop: '  בזיהוי לקוח קיים ימולאו אוטומטית הפרטים האישיים בלבד ללא מידע על מצב\nבריאותי.'
  },
  errorDialog: {
    title: `Page not found`,
    description: `לא הצלחנו להשלים את התהליך. אנא נסה שנית או צור קשר עם שירות הלקוחות\n בטלפון 9912*`,
    descriptionDesktop: `לא הצלחנו להשלים את התהליך. אנא נסה שנית או צור קשר עם שירות\n הלקוחות בטלפון 9912*.`,
    alternativeButtonText: 'למעבר לדף הבית',
    popUpImage: 'תמונת דיאלוג'
  },
  agentCardVerification: 'Card verification - 4 last digits',
  agentCardValidationError: 'Code is incorrect',
  agentDisclaimerPopup: {
    title: 'Before proceeding, we need your consent',
    disclaimerText:
      'I confirm that the sales process I carried out is documented (through a recording or in another way, other than an internal record) and the documentation will be preserved so that it can be located and transferred if I request it.',
    submitButtonText: 'Continue process'
  },
  agentEmailExistsErrorPopup: {
    title: 'Please choose a different email address',
    errorDescription:
      'The email address entered appears several times in the system, it is not possible to continue the purchase with this address'
  },
  accessibilityStatementPage: {
    headerSection: {
      title: 'הצהרת נגישות לתהליך רכישת פוליסת ביטוח נסיעות לחו"ל - פספורטכארד',
      description: `מערכת דיגיטלית זו, מאפשרת למשתמשים בה לרכוש פוליסת ביטוח נסיעות לחו"ל מבית פספורטכארד (להלן – החברה), בצורה מקוונת ומהירה.\n
מטרת החברה בהנגשת המערכת, היא יצירת שוויון הזדמנויות במרחב האינטרנטי לאנשים עם לקויות מגוונות ולאנשים הנעזרים בטכנולוגיות מסייעות שונות בעת גלישה ברשת האינטרנט.`
    },
    adjustmentsSection: {
      title: 'התאמות הנגישות במערכת המקוונת',
      description: `במערכת זו בוצעו התאמות נגישות בהתאם להמלצות התקן הישראלי (ת"י 5568) ולנגישות תכנים באינטרנט ברמת AA בשילוב המלצות מסמך WCAG2.0 שפורסם על ידי הארגון הבינלאומי W3C העוסק בתקינה ברשת האינטרנט.\n
ההתאמות שבוצעו במערכת נבדקו באמצעות הדפדפנים הנפוצים ביותר: גוגל כרום ואינטרנט אקספלורר (EDGE). לשם קבלת חווית גלישה נעימה ומיטבית עם תוכנה להקראת מסך, אנו ממליצים להשתמש בתוכנת NVDA  בגרסה העדכנית ביותר.`,
      implementedActions: {
        title: 'לצורך הנגשת המערכת לאנשים עם מוגבלות בוצעו מספר רב של פעולות, ביניהן:',
        items: {
          a: `יצירת סדר ניווט תקין וברור בעת ניווט ותפעול המערכת באמצעות המקלדת.`,
          b: `שימוש במסגרת ברורה ובולטת בעת קבלת פוקוס כאשר המשתמש מנווט במערכת באמצעות המקלדת.`,
          c: `שימוש בניגודיות חזותית מתאימה בין צבע הטקסט לצבע הרקע.`,
          d: `תיוג הכותרות בצורה היררכית נכונה בהתאם למידע המפורסם בהן ולמבנה העמוד.`,
          e: `יצירת שינוי חזותי בולט וברור בעת ריחוף באמצעות העכבר מעל אלמנטים קליקבילים (לחיצים) כגון: כפתורים וקישורים.`,
          f: `שימוש ברכיבים נגישים המאפשרים תפעול תקין באמצעות המקלדת בעת מעבר בין המסכים השונים.`
        }
      }
    },
    screenReaderAdjustments: {
      title: `התאמות שבוצעו במערכת המקוונת לגולשים המשתמשים בתוכנה להקראת מסך:`,
      items: {
        a: `הוספת טקסט אלטרנטיבי מתאים לתמונות המופיעות במערכת.`,
        b: `שימוש בכותרות עמוד מתאימות וברורות בהתאם למידע המופיע בעמוד.`,
        c: `שימוש בלייבלים מתאימים וברורים בשדות הקיימים במערכת.`,
        d: `שימוש בפקודת aria-label להתאמת המידע המופיע במערכת לתוכנה להקראת מסך.`,
        e: `שימוש בשפה פשוטה ובהירה בכל עמודי המערכת.`
      },
      description: `הייעוץ והליווי המקיף בנושא נגישות מערכת לרכישת פוליסת ביטוח מבית פספורטכארד בוצע על ידי <a href="#" id='accessibilityStatement'>https://www.passportcard.co.il/accessibility-statement/</a>.
יצוין כי ניתן לרכוש את פוליסת ביטוח הנסיעות של פספורטכארד גם באמצעות סוכני ביטוח, וכן באמצעות המוקד הטלפוני של החברה. במשרדי החברה לא מתקיימת קבלת קהל לצורך רכישת פוליסת ביטוח נסיעות לחו"ל.
למען הסר ספק, המידע המופיע בהצהרת נגישות זו מתייחס אך ורק לשימוש ותפעול המערכת המקוונת לרכישת פוליסת ביטוח נסיעות לחו"ל של החברה.
במידה והנכם מעוניינים לקבל מידע נוסף אודות שירותי החברה או מידע אודות התאמות הנגישות בשירותי החברה, יש לעבור להצהרת הנגישות המופיעה באתר הראשי של החברה בכתובת: <a href="#" id='accessibilitySupportCompany'>WEB-A הנגשת אתרים, אפליקציות ומערכות מתקדמות</a>.`
    },
    equalAbilitySection: {
      title: `צוות חברת פספורטכארד מאמין כי לכל אדם עם מוגבלות צריכה להיות היכולת להשתמש במערכת האינטרנט בצורה שווה, מהנה וחווייתית.`,
      description: `במערכת זה בוצעו שינויים והתאמות מיוחדות באמצעות הטכנולוגיה העדכנית והמתאימה ביותר לצרכי לקוחותינו והגולשים במערכת. עם זאת חשוב לציין כי ייתכן וימצאו אלמנטים מסוימים שאינם מונגשים בצורה מלאה או נמצאים בתהליכי הנגשה לאנשים עם מוגבלות.
נתקלתם ברכיב שאינו נגיש במערכת? פנו אלינו ואנו מבטיחים לבדוק לשפר אותו בהקדם האפשרי וכמובן להעניק לכם את השירות הטוב ביותר בצורה מהירה, אישית ובהתאם לשביעות רצונכם.`
    },
    hubDetailsSection: {
      title: `פרטי רכזת נגישות`,
      description: `החברה מינתה את עו"ד טל לנדאו לרכזת הנגישות של החברה.
לבירורים נוספים, שאלות או בקשות מיוחדות בנושא נגישות המערכת ניתן ליצור עימנו קשר באמצעים הבאים:`,
      updateDate: `הצהרת הנגישות עודכנה בתאריך 27/06/2024`,
      contacts: `שם מלא: עו"ד טל לנדאו\nטלפון במשרד: 09-8920930\nדואר אלקטרוני: `,
      contactEmail: `tall@passportcard.co.il`
    },
    footerSection: {
      description: `כל הזכויות בהצהרת נגישות זו שמורות לחברת WEB-A נגישות דיגיטלית בע"מ ואין להפיץ, להעתיק או לשכפל אותה.`
    }
  },
  quotePriceChangePopup: {
    title: 'Why has the price dropped',
    info: `Your {{productName}} quote includes cancellation cover from the date you completed your quote.

Now you’re closer to your departure date, the cost has reduced as it includes less days of pre-trip cancellation coverage and you’ll see this reflected in the new price.`
  },
  getInTouchPopup: {
    title: {
      ageRestriction: 'Please get in touch',
      generalError: `Oops something went wrong`
    },
    imgAlt: 'get_in_touch',
    information: {
      ageRestriction: `Due to the age you've entered we are not able to provide you with a quote online. Please get in touch with our Sydney-based team or complete the form below and a representative will be in touch within 1 business day.`,
      generalError: `Unfortunately, the process could not be completed. Call us for help or complete the form below and our team will phone you back.`
    },
    phoneNumber: '1300 123 413',
    phoneNumberAgent: '1300 123 414',
    submitButton: 'Get in touch',
    form: {
      firstName: 'First Name',
      lastName: 'Last Name',
      callingCode: 'Country',
      phoneNumber: 'Mobile',
      phonePlaceholder: 'E.g. 0402 123 456',
      noResult: 'Cannot be found'
    },
    success: {
      title: 'Thank you for submitting your details, a representative will be in touch.',
      button: 'Close'
    }
  },
  adultsToolTip: {
    title: 'Adults',
    tooltipText:
      'Your policy must have an adult aged 18 or older at the time of travel.<br>You can have up to {{maxAdults}} adults on the policy.<br>* All fields are mandatory.'
  },
  childrenTooltip: {
    title: 'Children / Dependants',
    tooltipText:
      'Children/Dependant means an Insured Person’s unmarried children (including step or legally adopted children) who are: (a) under 19 years of age; or (b) under 25 years of age and full-time students at an accredited institution of higher learning'
  },
  newTravelerCard: {
    ageLabel: 'Age at time of travel',
    stateLabel: 'Which state do you live in?',
    errors: {
      required: 'Required',
      adult: 'Please add as Child/Dependant',
      child: 'Please add as Adult',
      invalid: 'Invalid age'
    }
  },
  whoIsTravelling: {
    title: 'Who is travelling?',
    subtitle: 'List all travellers ages at time of travel',
    alertTitle: 'Live in separate households?',
    alertDescription: 'You may want individual polices so you both have your own PassportCard'
  },
  submissionPopupTitle: 'Thanks for submitting your details',
  deleteTravelerPopup: {
    title: 'Are you sure you want to delete {{firstName}} {{surName}}?',
    deleteButton: 'Yes - Delete',
    imgAlt: 'Passportcard Image'
  },
  optionalCovers: {
    add: 'Add',
    added: 'Added',
    title: 'Optional Covers',
    buttonAriaLabel: 'Details',
    buttonTitle: 'Details'
  },
  activityCovers: {
    add: 'Add',
    added: 'Added',
    title: 'Activity Covers',
    buttonAriaLabel: 'Details',
    buttonTitle: 'Details'
  },
  comprehensiveCovers: {
    title: 'Comprehensive Cover',
    subtitle: 'Our Comprehensive Cover Includes',
    included: 'Included',
    previous: 'previous',
    buttonAriaLabel: 'Details',
    buttonTitle: 'Details'
  },
  tripDetailsDisclaimer:
    'PassportCard Australia Pty Ltd (PassportCard) ABN 76 621 476 220 (AFSL 551 057) is an Underwriting Agency acting under Binder from Guild Insurance Limited (Guild) ABN 55 004 538 863 (AFSL 233 791). Any advice provided by PassportCard in relation to PassportCard products and the PassportCard is general advice only. Please consider the Combined Financial Services Guide & Product Disclosure Statement and the PassportCard Terms and Conditions (available at <a href="#"> https://www.passportcard.com.au/</a>) before deciding whether they are suitable for you.',
  DeliveryAddress: {
    title: 'Delivery Address',
    addressPickingTexts: {
      title: 'Where should we send your PassportCard?',
      deliveryAddressInputLabel: 'Delivery Address',
      billingAddressInputLabel: 'Billing Address',
      addressInputNoResult: 'No Result',
      addressInputPlaceholder: 'Enter Address',
      manualAddressText: "Can't find your address? Add manually",
      automaticAddressText: 'Return to previous address format',
      cityInputLabel: 'City',
      cityInputPlaceholder: 'Enter city',
      streetInputLabel: 'Street Address',
      streetInputPlaceholder: 'Enter Address',
      stateInputLabel: 'State',
      stateInputPlaceholder: 'Enter state',
      postcodeInputLabel: 'Postcode',
      postcodeInputPlaceholder: 'E.g. 1234'
    },
    billingAddressText: 'My billing address is the same as my delivery address',
    billingToggleTexts: {
      yes: 'Yes',
      no: 'No'
    },
    alertTitle: 'Why do I need a delivery address?',
    alertSubTitle: `Your physical PassportCard will be delivered to your address. Don't worry you're still covered without the card.`
  },
  Payment: {
    title: 'Secure Checkout',
    paymentRules: {
      offPeriod: '21 day cooling off period',
      daysOfWeekSupport: '24/7 Global Customer Support',
      cardInform: '2 million card holders worldwide',
      someInfo: 'Canstar winning travel insurance'
    },
    paymentDisclaimer:
      'Your payment and personal details are stored securely. For more information please read our Privacy Policy.',
    paymentRulesTitle: 'Purchase with peace-of-mind'
  },
  ReferralPopup: {
    titleDefault: 'We need to speak with you',
    titleActivePolicy: 'A policy already exists for these dates',
    titleCardError: 'Your payment has failed',
    titleCommonErrorPolicy: 'Oops something went wrong',
    titleAfterConfirmation: 'We’ll call you back',

    textInformation: 'Based on the information provided, we need to talk to you to complete your medical assessment',
    textActivePolicy: 'If you need to extend or change the dates of your policy, please call us.',
    textInformationCommonErrorPolicy: 'Unfortunately, the process could not be completed.',
    textCardError: 'Please try again or call us.',
    textInformationAfterConfirmation: 'You’re almost there!',
    textSubInformation:
      'One of our Sydney-based representatives will be in contact with you within 1 business day or you can call us using the number below.',
    textSubInformationAfterConfirmation: 'Thank you for submitting your details. Someone will be in touch soon. ',
    buttonText: 'Summary of Cover',
    buttonTextAfterConfirmation: 'Close',
    secondaryButtonText: '<a href=tel:{{noSpacePhone}}>{{phone}}</a> '
  }
};

export default enUS;
